module.exports = __webpack_public_path__ + "static/media/02.ea26eb34.jpg";